import { PropsWithChildren } from 'react';

export type ToastProps = PropsWithChildren<{
  title?: string;
  message?: React.ReactNode;
  type: 'success' | 'error' | 'info' | 'warning';
  onClose?: () => void;
}>;

const baseColorByType: Record<ToastProps['type'], string> = {
  success: 'green',
  error: 'red',
  info: 'blue',
  warning: 'yellow',
};

export const Toast: React.FC<ToastProps> = ({ title, message, children, type, onClose }) => {
  const baseColor = baseColorByType[type];

  return (
    <div
      className={`toast flex items-start p-4 bg-${baseColor}-50 rounded-lg border border-${baseColor}-100 shadow-lg`}
    >
      <div className="flex-shrink-0">
        <svg className={`w-5 h-5 text-${baseColor}-500`} fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="ml-3">
        {title && <h3 className={`text-sm font-medium text-${baseColor}-800`}>{title}</h3>}
        {message && <p className={`mt-1 text-sm text-${baseColor}-600`}>{message}</p>}
        {children}
      </div>
      {onClose && (
        <button
          className={`ml-auto text-${baseColor}-400 hover:text-${baseColor}-500`}
          onClick={() => onClose()}
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </div>
  );
};
